import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalsService } from 'src/app/core/services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class RadiationMachineService {
  constructor(private http: HttpClient, private globals: GlobalsService) { }

  // Add your service methods here

  getMachineTypes() {
    let url = `${this.globals.dataUrl}machineType`;
    return this.http.get(url);
  }

  getMachinePurposes() {
    let url = `${this.globals.dataUrl}machinePurpose`;
    return this.http.get(url);
  }

  createMachine(machineData: any): Observable<any> {
    let url = `${this.globals.dataUrl}radiationMachine`;
    console.log(machineData, url);
    return this.http.post(url, machineData);
  }

  getMachineById(id: number): Observable<any> {
    let url = `${this.globals.dataUrl}radiationMachine/requirement/${id}`;
    return this.http.get(url);
  }

  updateMachine(id: any, machineData: any) {
    let url = `${this.globals.dataUrl}radiationMachine/${id}`;
    return this.http.put(url, machineData);
  }

  editMachine(id: any, machineData: any) {
    let url = `${this.globals.dataUrl}radiationMachine/${id}`;
    return this.http.put(url, machineData);
  }

  deleteMachine(id: any) {
    let url = `${this.globals.dataUrl}radiationMachine/${id}`;
    return this.http.delete(url);
  }

  getCostByProcessId(processId: any) {
    let url = `${this.globals.dataUrl}radiationMachine/${processId}/costs`;
    return this.http.get(url);
  }

  getInspectionMachineTransactions(page: number, pageSize: number, term: string){
    let url = `${this.globals.dataUrl}radiationMachine/inspectionMachineTransactions?page=${page}&size=${pageSize}&term=${term}`;
    return this.http.get(url);
  }

  getByProponentId(proponentId: any, page: number, pageSize: number) {
    let url = `${this.globals.dataUrl}radiationMachine/proponent?proponentId=${proponentId}&page=${page}&size=${pageSize}`;
    return this.http.get(url);
  }

  getAllByProponentId(proponentId: any) {
    let url = `${this.globals.dataUrl}radiationMachine/proponentAll/${proponentId}`;
    return this.http.get(url);
  }

  inspectionUpsert(inspectionData: any) {
    let url = `${this.globals.dataUrl}radiationMachine/inspection`;
    return this.http.post(url, inspectionData);
  }

  getInspectionByUserProcessId(userProcessId: any) {
    let url = `${this.globals.dataUrl}radiationMachine/inspection/${userProcessId}`;
    return this.http.get(url);
  }
}